import type { JSX } from 'react';
import { PRIVACY_LAST_UPDATED } from './privacyPrimitives';
import {
  CollectedDataSection,
  ControllerSection,
  CookiesSection,
  LegalBasisSection,
  RecipientsSection,
  RetentionSection,
  RightsSection,
} from './privacySections';

export { PRIVACY_CONTACT_EMAIL } from './privacyPrimitives';

export function PrivacyPolicyPage(): JSX.Element {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:py-16">
      <article className="space-y-10 text-sm leading-relaxed sm:text-base">
        <header className="space-y-3">
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Privacy Notice</h1>
          <p className="text-muted-foreground">
            This notice explains how Career Verification processes personal data of candidates and
            the reference contacts who confirm them. It applies to the Career Verification
            application and the verification links we send by email.
          </p>
          <p className="text-sm text-muted-foreground">Last updated: {PRIVACY_LAST_UPDATED}</p>
        </header>

        <ControllerSection />
        <CollectedDataSection />
        <LegalBasisSection />
        <RecipientsSection />
        <RetentionSection />
        <RightsSection />
        <CookiesSection />

        <footer className="border-t pt-6 text-sm text-muted-foreground">
          <p>Last updated: {PRIVACY_LAST_UPDATED}</p>
        </footer>
      </article>
    </main>
  );
}
